/**
 * Used to log a message to datadog. Currently just console.logs which gets picked up in Vercel log drains but will be exploring a better alternative to do this in the future
 * @param severity - log severity
 * @param logData - log data
 */

export const logToDatadog = (
  severity: "error" | "info" | "warning",
  ...logData: any[]
) => {
  switch (severity) {
    case "error":
      console.error(...logData);
      break;
    case "info":
      console.log(...logData);
      break;
    case "warning":
      console.warn(...logData);
  }
};
